export const titleSuffix =
  import.meta.env.VITE_MODE === 'ppg'
    ? '- PayPayポイントがもらえる飲食店探し・ネット予約グルメサイト'
    : '[一休.comレストラン]'
